export default "__VITE_ASSET__XR$59BvJ__"